import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";

type Option = { id: number; name: string };

type Props = {
  id: string;
  label: string;
  options: Option[];
  value: number | null;
  disabled: boolean;
  requiredText: string;
  onChange: (optionId: number) => void;
};

export default function OptionSelect({
  id,
  label,
  options,
  value,
  disabled,
  requiredText,
  onChange,
}: Props) {
  return (
    <FormControl
      fullWidth
      size="small"
      required
      error={value === null}
      disabled={disabled}
    >
      <InputLabel id={`${id}-label`}>{label}</InputLabel>
      <Select
        labelId={`${id}-label`}
        label={label}
        value={value ?? ""}
        onChange={(event) => onChange(Number(event.target.value))}
        data-testid={`lidar-upload-status.${id}`}
      >
        {options.map((option) => (
          <MenuItem
            key={option.id}
            value={option.id}
            data-testid={`lidar-upload-status.${id}.option.${option.id}`}
          >
            {option.name}
          </MenuItem>
        ))}
      </Select>
      {value === null && <FormHelperText>{requiredText}</FormHelperText>}
    </FormControl>
  );
}
